import React, { PropsWithChildren } from 'react';
import { Col, Card, CardBody, CardTitle, Badge } from 'reactstrap';

const Group = ({
  linkId,
  children,
  title,
}: PropsWithChildren<{ linkId: string; title: string }>) => (
  <Col className="col-auto flex-grow-1 mb-2 qtnnaire-report-group">
    <Card className="qtnnaire-report-group h-100">
      <CardBody>
        <CardTitle tag="h3">
          <Badge className="mr-2">{linkId}</Badge>
          {title}
        </CardTitle>
        <div className="pl-4">{children}</div>
      </CardBody>
    </Card>
  </Col>
);

export default Group;
